import { render, staticRenderFns } from "./RagioneriaTipiOspiteView.vue?vue&type=template&id=bbf23d70&"
import script from "./RagioneriaTipiOspiteView.vue?vue&type=script&lang=ts&"
export * from "./RagioneriaTipiOspiteView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports